import { render } from "./DynamicColumn.vue?vue&type=template&id=163c6f4d&ts=true"
import script from "./DynamicColumn.vue?vue&type=script&lang=ts"
export * from "./DynamicColumn.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"shared/src/entidades/builder/form/infrastructure/controls/editorTemplates/prime/DynamicColumn.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "163c6f4d"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('163c6f4d', __exports__)) {
    api.reload('163c6f4d', __exports__)
  }
  
  module.hot.accept("./DynamicColumn.vue?vue&type=template&id=163c6f4d&ts=true", () => {
    api.rerender('163c6f4d', render)
  })

}


export default __exports__